import { capitalize } from 'lodash'
import { useTranslation } from 'react-i18next'

import { Badge, Button, CardDashboard } from '@percent/lemonade'
import styles from './OrganisationRelationships.module.scss'
import { OrganisationRelationshipsProps } from './OrganisationRelationships.types'

export function OrganisationRelationships({ relationships }: Readonly<OrganisationRelationshipsProps>) {
  const { t } = useTranslation()

  if (!relationships || relationships?.length === 0) return null

  return (
    <CardDashboard title={t('typography.relationships')}>
      <div className={styles.relationships}>
        {relationships?.map(({ result, type, relationship }) => (
          <div key={result.id} className={styles.relationshipWrapper}>
            <div className={styles.relationshipDetails}>
              <span>{result.name}</span>
              <Badge variant="informative">
                {t(type === 'branch' ? 'typography.branch' : 'typography.fiscalSponsorship', {
                  relationship: capitalize(relationship)
                })}
              </Badge>
            </div>
            <Button
              size="small"
              variant="secondary"
              onClick={() => {
                window.open(`${window.location.origin}/organizations/${result.id}`, '_blank')
              }}
            >
              {t('button.goToOrganisationDetails')}
            </Button>
          </div>
        ))}
      </div>
    </CardDashboard>
  )
}
